module.exports = __webpack_public_path__ + "static/media/github.a8ae8417.svg";